// English is the default; German is only reached through the toggle.
const strings = {
  en: {
    lang: 'en',
    toggleLabel: 'EN',
    recentProjects: 'Recent Projects',
    viewMore: 'View More',
    projects: 'Projects',
    searchLabel: 'Search projects by keyword',
    back: 'Back',
    noMatch: 'No projects match your search.',
    impressum: 'Impressum',
    privacy: 'Privacy',
  },
  de: {
    lang: 'de',
    toggleLabel: 'DE',
    recentProjects: 'Aktuelle Projekte',
    viewMore: 'Mehr anzeigen',
    projects: 'Projekte',
    searchLabel: 'Projekte nach Stichwort durchsuchen',
    back: 'Zurück',
    noMatch: 'Keine Projekte gefunden.',
    impressum: 'Impressum',
    privacy: 'Datenschutz',
  },
};

export default strings;
